import React, { useEffect, useMemo } from "react";

import InputField from "../Component/Inputs/InputField";
import MultiSelectCheckBox from "../Component/Inputs/MultiSelectCheckBox";
import RadioInput from "../Component/Inputs/RadioInput";
import RadioChips from "../Component/Inputs/RadioChips";
import MultiSelectDropDown from "../Component/Inputs/MultiSelectDropDown";
import OktaUserMultiSelect from "../Component/Inputs/OktaUserMultiSelect";
import ToggleButton from "../Component/Inputs/ToggleButton";
import SingleSelectDropdown from "../Component/Inputs/SingleSelectDropdown";
import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";
import { LightTooltip } from "../../../kit/LightToolTip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Grid from "@mui/material/Grid";
import {
  updateRapidInfraData,
  updateTotalCostData,
} from "../../../redux/slice/dataSlice";
import { useDispatch, useSelector } from "react-redux";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EastIcon from "@mui/icons-material/East";
import WestIcon from "@mui/icons-material/West";
import { v4 } from "uuid";
import { useStyles } from "../../../theme/style";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { updateAlertInfo } from "../../../redux/slice/userSlice";
import CheckboxField from "../Component/Inputs/CheckboxField";
import APP_CONSTANTS from "../../../utils/config";
import {
  getTotalCost,
  isNextDisabled,
  getDevEnvironment,
  isSaveAsDraftActive,
} from "../../../utils/utils";

import "../Component/Inputs/style.scss";
import { rapidSaveAsDraft } from "../../../services/api";
import { useNavigate } from "react-router-dom";

const HorizontalDivider = () => {
  return (
    <div
      style={{
        borderBottom: "1px solid #E0E0E0",
      }}
    ></div>
  );
};
const InfraSection1 = ({ getComponent, data, components, theme }) => {
  const gridConfig = {
    0: { xs: 4 },
    1: { xs: 6 },
  };

  return (
    <div>
      {/* Heading */}
      {data.category_name !== "" && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginBottom: theme.size[8],
          }}
        >
          <Typography
            sx={{
              fontSize: theme.size[14],
              fontWeight: theme.fontWeight[500],
              color: theme.palette.rapidInfra.text,
            }}
          >
            {data.category_name}
          </Typography>

          {data.info !== "" && (
            <LightTooltip
              title={data.info}
              placement="top"
              arrow
              sx={{
                "& .MuiTooltip-tooltip": {
                  padding: "8px 12px", // Adjust padding if needed
                },
              }}
            >
              <InfoOutlinedIcon
                style={{
                  fontSize: theme.size[14],
                  color: theme.palette.rapidInfra.infoIcon,
                  marginLeft: 5,
                  cursor: "pointer",
                }}
              />
            </LightTooltip>
          )}
        </Box>
      )}

      <Grid container columnSpacing={5}>
        {components.map((curr_component, index) => {
          if (gridConfig.hasOwnProperty(index)) {
            return (
              <Grid item xs={gridConfig[index].xs} key={index}>
                {getComponent(data, curr_component)}
              </Grid>
            );
          } else {
            return (
              <Grid item xs={4} key={index}>
                {getComponent(data, curr_component)}
              </Grid>
            );
          }
        })}
      </Grid>
    </div>
  );
};

const InfraSection2 = ({
  getComponent,
  data,
  components,
  data2,
  components2,
  theme,
}) => {
  return (
    <div>
      {/* Heading */}
      {data.category_name !== "" && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginBottom: theme.size[8],
          }}
        >
          <Typography
            sx={{
              fontSize: theme.size[14],
              fontWeight: theme.fontWeight[500],
              color: theme.palette.rapidInfra.text,
            }}
          >
            {data.category_name}
          </Typography>

          {data.info !== "" && (
            <LightTooltip
              title={data.info}
              placement="top"
              arrow
              sx={{
                "& .MuiTooltip-tooltip": {
                  padding: "8px 12px", // Adjust padding if needed
                },
              }}
            >
              <InfoOutlinedIcon
                style={{
                  fontSize: theme.size[14],
                  color: theme.palette.rapidInfra.infoIcon,
                  marginLeft: 5,
                  cursor: "pointer",
                }}
              />
            </LightTooltip>
          )}
        </Box>
      )}

      {/* Component */}
      <div style={{ margin: `${theme.size[24]} ${theme.size[16]}` }}>
        {(() => {
          const leanixField = components[0];
          const appUrlField = components[1];
          const handleMatch = (c) =>
            c &&
            typeof c.component_name === "string" &&
            c.component_name.toLowerCase().includes("handle");
          const handleField =
            components.find(handleMatch) || components2?.find(handleMatch);

          // Standard three-column layout without Gen AI dropdown
          return (
            <Grid container columnSpacing={5}>
              <Grid item xs={3}>
                {getComponent(data, leanixField)}
              </Grid>
              <Grid item xs={6}>
                <div>{getComponent(data, appUrlField)}</div>
              </Grid>
              <Grid item xs={3}>
                <div>{getComponent(data, handleField)}</div>
              </Grid>
            </Grid>
          );
        })()}
      </div>
      <HorizontalDivider />
      <div style={{ margin: `${theme.size[24]} ${theme.size[16]}` }}>
        <Grid container columnSpacing={5}>
          <Grid item xs={6}>
            {getComponent(data2, components2[0])}
          </Grid>
          <Grid item xs={6}>
            <div>{getComponent(data2, components2[1])}</div>
          </Grid>
        </Grid>
      </div>
      <HorizontalDivider />
    </div>
  );
};

const InfraSection3 = ({
  getComponent,
  data,
  components,
  theme,
  isRegistering,
}) => {
  const gridConfig = {
    0: { xs: 4 },
    1: { xs: 7 },
    2: { xs: 4 },
    3: { xs: 4 },
    4: { xs: 4 },
  };
  return (
    <div>
      {/* Heading */}
      {data.category_name !== "" && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            // marginBottom: theme.size[8],
            margin: `${theme.size[24]} ${theme.size[16]} ${theme.size[8]} ${theme.size[16]}`,
          }}
        >
          <Typography
            sx={{
              fontSize: theme.size[14],
              fontWeight: theme.fontWeight[500],
              color: theme.palette.rapidInfra.text,
            }}
          >
            {data.category_name}
          </Typography>

          {data.info !== "" && (
            <LightTooltip
              title={data.info}
              placement="top"
              arrow
              sx={{
                "& .MuiTooltip-tooltip": {
                  padding: "8px 12px", // Adjust padding if needed
                },
              }}
            >
              <InfoOutlinedIcon
                style={{
                  fontSize: theme.size[14],
                  color: theme.palette.rapidInfra.infoIcon,
                  marginLeft: 5,
                  cursor: "pointer",
                }}
              />
            </LightTooltip>
          )}

          {isRegistering && (
            <Typography
              sx={{
                fontSize: theme.size[12],
                fontWeight: theme.fontWeight[500],
                color: theme.palette.secondary.main,
                marginLeft: theme.size[8],
              }}
            >
              Default Services (Non-Editable)
            </Typography>
          )}
        </Box>
      )}
      {/* Component */}
      <div
        style={{
          margin: `0 ${theme.size[16]} ${theme.size[24]} ${theme.size[16]}`,
        }}
      >
        <Grid container columnSpacing={5} rowSpacing={2}>
          {components.map((curr_component, index) => {
            if (gridConfig.hasOwnProperty(index)) {
              return (
                <Grid item xs={gridConfig[index].xs} key={index}>
                  {getComponent(data, curr_component)}
                </Grid>
              );
            } else {
              return (
                <Grid item xs={4} key={index}>
                  {getComponent(data, curr_component)}
                </Grid>
              );
            }
          })}
        </Grid>
      </div>
      <HorizontalDivider />
    </div>
  );
};

const InfraSection4 = ({ getComponent, data, components, theme }) => {
  const gridConfig = {
    0: { xs: 5 },
    1: { xs: 4 },
  };

  return (
    <div>
      {/* Heading */}
      {data.category_name !== "" && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            // marginBottom: theme.size[8],
            margin: `${theme.size[24]} ${theme.size[16]} ${theme.size[8]} ${theme.size[16]}`,
          }}
        >
          <Typography
            sx={{
              fontSize: theme.size[14],
              fontWeight: theme.fontWeight[500],
              color: theme.palette.rapidInfra.text,
            }}
          >
            {data.category_name}
          </Typography>

          {data.info !== "" && (
            <LightTooltip
              title={data.info}
              placement="top"
              arrow
              sx={{
                "& .MuiTooltip-tooltip": {
                  padding: "8px 12px", // Adjust padding if needed
                },
              }}
            >
              <InfoOutlinedIcon
                style={{
                  fontSize: theme.size[14],
                  color: theme.palette.rapidInfra.infoIcon,
                  marginLeft: 5,
                  cursor: "pointer",
                }}
              />
            </LightTooltip>
          )}
        </Box>
      )}

      {/* Component */}
      <div
        style={{
          margin: `0 ${theme.size[16]} ${theme.size[24]} ${theme.size[16]}`,
        }}
      >
        <Grid container columnSpacing={5}>
          {components.map((curr_component, index) => {
            if (gridConfig.hasOwnProperty(index)) {
              return (
                <Grid item xs={gridConfig[index].xs} key={index}>
                  {getComponent(data, curr_component)}
                </Grid>
              );
            } else {
              return (
                <Grid item xs={4} key={index}>
                  {getComponent(data, curr_component)}
                </Grid>
              );
            }
          })}
        </Grid>
      </div>
      <HorizontalDivider />
    </div>
  );
};

// Unstructured ETL
const InfraSection6 = ({ getComponent, data, components, theme }) => {
  const gridConfig = {
    0: { xs: 4 },
    1: { xs: 4 },
    2: { xs: 4 },
  };
  return (
    <div>
      {/* Heading */}
      {data.category_name !== "" && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            // marginBottom: theme.size[8],
            margin: `${theme.size[24]} ${theme.size[16]} ${theme.size[8]} ${theme.size[16]}`,
          }}
        >
          <Typography
            sx={{
              fontSize: theme.size[14],
              fontWeight: theme.fontWeight[500],
              color: theme.palette.rapidInfra.text,
            }}
          >
            {data.category_name}
          </Typography>

          {data.info !== "" && (
            <LightTooltip
              title={data.info}
              placement="top"
              arrow
              sx={{
                "& .MuiTooltip-tooltip": {
                  padding: "8px 12px", // Adjust padding if needed
                },
              }}
            >
              <InfoOutlinedIcon
                style={{
                  fontSize: theme.size[14],
                  color: theme.palette.rapidInfra.infoIcon,
                  marginLeft: 5,
                  cursor: "pointer",
                }}
              />
            </LightTooltip>
          )}
        </Box>
      )}

      <div
        style={{
          margin: `0 ${theme.size[16]} ${theme.size[24]} ${theme.size[16]}`,
          backgroundColor: theme.palette.form.fieldBackground,
          padding: `${theme.size[16]} ${theme.size[12]}`,
          borderRadius: theme.size[8],
        }}
      >
        <Grid container columnSpacing={5} rowSpacing={3}>
          {components.map((curr_component, index) => {
            if (index === 0) {
              return null;
            }
            if (gridConfig.hasOwnProperty(index)) {
              return (
                <Grid item xs={gridConfig[index].xs} key={index}>
                  {getComponent(data, curr_component)}
                </Grid>
              );
            } else {
              return (
                <Grid item xs={4} key={index}>
                  {getComponent(data, curr_component)}
                </Grid>
              );
            }
          })}
        </Grid>
      </div>
      <HorizontalDivider />
    </div>
  );
};

const InfraSection7 = ({ getComponent, data, components, theme }) => {
  const gridConfig = {
    0: { xs: 12, sm: 3, md: 4, lg: 2 },
    1: { xs: 12, sm: 9, md: 6, lg: 5 },
    2: { xs: 12, sm: 6, md: 6, lg: 5 },
  };
  return (
    <div>
      {/* Heading */}
      {data.category_name !== "" && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            // marginBottom: theme.size[8],
            margin: `${theme.size[24]} ${theme.size[16]} ${theme.size[8]} ${theme.size[16]}`,
          }}
        >
          <Typography
            sx={{
              fontSize: theme.size[14],
              fontWeight: theme.fontWeight[500],
              color: theme.palette.rapidInfra.text,
            }}
          >
            {data.category_name}
          </Typography>

          {data.info !== "" && (
            <LightTooltip
              title={data.info}
              placement="top"
              arrow
              sx={{
                "& .MuiTooltip-tooltip": {
                  padding: "8px 12px", // Adjust padding if needed
                },
              }}
            >
              <InfoOutlinedIcon
                style={{
                  fontSize: theme.size[14],
                  color: theme.palette.rapidInfra.infoIcon,
                  marginLeft: 5,
                  cursor: "pointer",
                }}
              />
            </LightTooltip>
          )}
        </Box>
      )}

      {/* Component */}
      <div
        style={{
          margin: `0 ${theme.size[16]} ${theme.size[24]} ${theme.size[16]}`,
        }}
      >
        <Grid container columnSpacing={5} rowSpacing={2}>
          {components.map((curr_component, index) => {
            if (gridConfig.hasOwnProperty(index)) {
              return (
                <Grid
                  item
                  xs={gridConfig[index].xs}
                  sm={gridConfig[index].sm}
                  md={gridConfig[index].md}
                  lg={gridConfig[index].lg}
                  key={index}
                >
                  {getComponent(data, curr_component)}
                </Grid>
              );
            } else {
              return (
                <Grid item xs={4} key={index}>
                  {getComponent(data, curr_component)}
                </Grid>
              );
            }
          })}
        </Grid>
      </div>
      <HorizontalDivider />
    </div>
  );
};

const InfraSection8 = ({ getComponent, data, components, theme }) => {
  const gridConfig = {
    0: { xs: 5 },
    1: { xs: 2 },
    2: { xs: 5 },
  };
  return (
    <div>
      {/* Heading */}
      {data.category_name !== "" && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            // marginBottom: theme.size[8],
            margin: `${theme.size[24]} ${theme.size[16]} ${theme.size[8]} ${theme.size[16]}`,
          }}
        >
          <Typography
            sx={{
              fontSize: theme.size[14],
              fontWeight: theme.fontWeight[500],
              color: theme.palette.rapidInfra.text,
            }}
          >
            {data.category_name}
          </Typography>

          {data.info !== "" && (
            <LightTooltip
              title={data.info}
              placement="top"
              arrow
              sx={{
                "& .MuiTooltip-tooltip": {
                  padding: "8px 12px", // Adjust padding if needed
                },
              }}
            >
              <InfoOutlinedIcon
                style={{
                  fontSize: theme.size[14],
                  color: theme.palette.rapidInfra.infoIcon,
                  marginLeft: 5,
                  cursor: "pointer",
                }}
              />
            </LightTooltip>
          )}
        </Box>
      )}

      {/* Component */}
      <div
        style={{
          margin: `0 ${theme.size[16]} ${theme.size[24]} ${theme.size[16]}`,
        }}
      >
        <Grid container columnSpacing={5}>
          {components.map((curr_component, index) => {
            if (gridConfig.hasOwnProperty(index)) {
              return (
                <Grid item xs={gridConfig[index].xs} key={index}>
                  {getComponent(data, curr_component)}
                </Grid>
              );
            } else {
              return (
                <Grid item xs={4} key={index}>
                  {getComponent(data, curr_component)}
                </Grid>
              );
            }
          })}
        </Grid>
      </div>
      <HorizontalDivider />
    </div>
  );
};

// Custom Requirements
const InfraSection9 = ({
  data,
  theme,
  categoryID,
  componentID,
  value,
  handleAddNewRequirement,
  handleDeleteRequirement,
  handleCustomRequirementChange,
  isDisabled,
}) => {
  return (
    <div>
      {/* Heading */}
      {data.category_name !== "" && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            // marginBottom: theme.size[8],
            margin: `${theme.size[24]} ${theme.size[16]} ${theme.size[8]} ${theme.size[16]}`,
          }}
        >
          <Typography
            sx={{
              fontSize: theme.size[14],
              fontWeight: theme.fontWeight[500],
              color: theme.palette.rapidInfra.text,
            }}
          >
            {data.category_name}
          </Typography>

          {data.info !== "" && (
            <LightTooltip
              title={data.info}
              placement="top"
              arrow
              sx={{
                "& .MuiTooltip-tooltip": {
                  padding: "8px 12px", // Adjust padding if needed
                },
              }}
            >
              <InfoOutlinedIcon
                style={{
                  fontSize: theme.size[14],
                  color: theme.palette.rapidInfra.infoIcon,
                  marginLeft: 5,
                  cursor: "pointer",
                }}
              />
            </LightTooltip>
          )}
        </Box>
      )}

      {/* Component */}
      <div
        style={{
          margin: `${theme.size[16]} ${theme.size[16]} ${theme.size[24]} ${theme.size[16]}`,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            marginBottom: theme.size[8],
          }}
        >
          <Typography
            sx={{
              fontSize: theme.size[14],
              fontWeight: theme.fontWeight[500],
              marginRight: theme.size[12],
              color: theme.palette.rapidInfra.text,
            }}
          >
            {data.components[0].component_name}
          </Typography>
          {!isDisabled && (
            <Typography
              sx={{
                fontSize: theme.size[14],
                fontWeight: theme.fontWeight[500],
                color: theme.palette.secondary.main,
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() => {
                handleAddNewRequirement(categoryID, componentID);
              }}
            >
              Add Requirement
            </Typography>
          )}
        </Box>

        {value.length > 0 && (
          <>
            <Box
              sx={{
                display: "flex",
              }}
            >
              {/* Requirement Name */}
              <Box
                sx={{
                  width: "40%",
                  marginRight: theme.size[12],
                }}
              >
                <Typography
                  sx={{
                    fontSize: theme.size[14],
                    fontWeight: theme.fontWeight[500],
                    color: theme.palette.rapidInfra.text,
                  }}
                >
                  Requirement Name
                </Typography>

                {value.map((item) => {
                  return (
                    <div
                      key={item.id}
                      style={{
                        marginTop: theme.size[12],
                      }}
                    >
                      <input
                        type={"text"}
                        value={item.name}
                        placeHolder={"Enter Requirement Name"}
                        disabled={isDisabled}
                        className="custom-input"
                        onChange={(e) => {
                          handleCustomRequirementChange(
                            categoryID,
                            componentID,
                            item.id,
                            e.target.value,
                            "name"
                          );
                        }}
                        style={{
                          width: "100%",
                          padding: "8.5px 8px",
                          borderRadius: theme.size[5],
                          border: "none",
                          outline: "none",
                          fontSize: theme.size[14],
                          backgroundColor: theme.palette.form.fieldBackground,
                          fontWeight: theme.fontWeight[400],
                          color: isDisabled
                            ? "#B0B0B0"
                            : theme.palette.form.text,
                        }}
                      />
                    </div>
                  );
                })}
              </Box>

              {/* Requirement Description */}
              <Box
                sx={{
                  width: "40%",
                  marginRight: theme.size[12],
                }}
              >
                <Typography
                  sx={{
                    fontSize: theme.size[14],
                    fontWeight: theme.fontWeight[500],
                    color: theme.palette.rapidInfra.text,
                  }}
                >
                  Requirement Description
                </Typography>
                {value.map((item) => {
                  return (
                    <div
                      key={item.id}
                      style={{
                        marginTop: theme.size[12],
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type={"text"}
                        value={item.description}
                        placeHolder={"Enter Requirement Description"}
                        disabled={isDisabled}
                        className="custom-input"
                        onChange={(e) => {
                          handleCustomRequirementChange(
                            categoryID,
                            componentID,
                            item.id,
                            e.target.value,
                            "description"
                          );
                        }}
                        style={{
                          width: "100%",
                          padding: "8.5px 8px",
                          borderRadius: theme.size[5],
                          border: "none",
                          outline: "none",
                          fontSize: theme.size[14],
                          backgroundColor: "#F8F8F8",
                          fontWeight: theme.fontWeight[400],
                          color: isDisabled
                            ? "#B0B0B0"
                            : theme.palette.form.text,
                        }}
                      />
                    </div>
                  );
                })}
              </Box>

              {/* Cost */}
              <Box
                sx={{
                  width: "20%",
                }}
              >
                <Typography
                  sx={{
                    fontSize: theme.size[14],
                    fontWeight: theme.fontWeight[500],
                    color: theme.palette.rapidInfra.text,
                  }}
                >
                  Tentative Monthly Cost
                  <span
                    style={{
                      color: theme.palette.rapidInfra.required,
                      marginLeft: theme.size[4],
                    }}
                  >
                    *
                  </span>
                  <LightTooltip
                    title={
                      "Combined tentative monthly cost of selected environments (Dev, UAT, and Prod)"
                    }
                    placement="top"
                    arrow
                    sx={{
                      "& .MuiTooltip-tooltip": {
                        padding: "8px 12px", // Adjust padding if needed
                      },
                    }}
                  >
                    <InfoOutlinedIcon
                      style={{
                        fontSize: theme.size[14],
                        color: theme.palette.rapidInfra.infoIcon,
                        marginLeft: 5,
                        cursor: "pointer",
                      }}
                    />
                  </LightTooltip>
                </Typography>

                {value.map((item) => {
                  return (
                    <div
                      key={item.id}
                      style={{
                        marginTop: theme.size[12],
                        display: "flex",
                        alignItems: "center",
                        position: "relative",
                      }}
                    >
                      {item?.cost !== "" && (
                        <span
                          style={{
                            position: "absolute",
                            left: "8px",
                            fontSize: theme.size[14],
                            fontWeight: theme.fontWeight[500],
                            color: theme.palette.rapidInfra.text,
                            background: "#F8F8F8",
                          }}
                        >
                          $
                        </span>
                      )}
                      <input
                        type={"text"}
                        value={item?.cost || ""}
                        placeHolder={"Enter Tentative Monthly Cost"}
                        className="custom-input"
                        disabled={isDisabled}
                        onChange={(e) => {
                          if (
                            e.target.value === "" ||
                            /^\d+(\.\d*)?$/.test(e.target.value)
                          ) {
                            handleCustomRequirementChange(
                              categoryID,
                              componentID,
                              item.id,
                              e.target.value,
                              "cost"
                            );
                          }
                        }}
                        style={{
                          width: "100%",
                          padding:
                            item?.cost !== ""
                              ? "8.5px 8px 8.5px 20px"
                              : "8.5px 8px",
                          borderRadius: theme.size[5],
                          border: "none",
                          outline: "none",
                          fontSize: theme.size[14],
                          backgroundColor: "#F8F8F8",
                          fontWeight: theme.fontWeight[400],
                          color: isDisabled
                            ? "#B0B0B0"
                            : theme.palette.form.text,
                        }}
                      />
                      {!isDisabled && (
                        <DeleteOutlineOutlinedIcon
                          sx={{
                            fontSize: theme.size[24],
                            color: theme.palette.secondary.main,
                            cursor: "pointer",
                            marginLeft: theme.size[4],
                          }}
                          onClick={() =>
                            handleDeleteRequirement(
                              categoryID,
                              componentID,
                              item.id
                            )
                          }
                        />
                      )}
                    </div>
                  );
                })}
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                fontSize: theme.size[12],
                fontWeight: theme.fontWeight[500],
                color: theme.palette.secondary.main,
                marginRight: theme.size[28],
                marginTop: theme.size[4],
              }}
            >
              *Combined tentative monthly cost of selected environments (Dev,
              UAT, and Prod)
            </Box>
          </>
        )}
      </div>
      <HorizontalDivider />
    </div>
  );
};

const InfraSection10 = ({ getComponent, data, components, theme }) => {
  const gridConfig = {
    0: { xs: 12 },
  };
  return (
    <>
      <div
        style={{
          margin: `${theme.size[24]} ${theme.size[16]} ${theme.size[8]} ${theme.size[16]}`,
        }}
      >
        {/* Heading */}
        {data.category_name !== "" && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              // marginBottom: theme.size[8],
            }}
          >
            <Typography
              sx={{
                fontSize: theme.size[14],
                fontWeight: theme.fontWeight[500],
                color: theme.palette.rapidInfra.text,
              }}
            >
              {data.category_name}
            </Typography>

            {data.info !== "" && (
              <LightTooltip
                title={data.info}
                placement="top"
                arrow
                sx={{
                  "& .MuiTooltip-tooltip": {
                    padding: "8px 12px", // Adjust padding if needed
                  },
                }}
              >
                <InfoOutlinedIcon
                  style={{
                    fontSize: theme.size[14],
                    color: theme.palette.rapidInfra.infoIcon,
                    marginLeft: 5,
                    cursor: "pointer",
                  }}
                />
              </LightTooltip>
            )}
          </Box>
        )}

        {/* Component */}
        <div
          style={{
            // margin: `0 ${theme.size[16]} ${theme.size[24]} ${theme.size[16]}`,
            marginBottom: theme.size[24],
          }}
        >
          <Grid container columnSpacing={5}>
            {components.map((curr_component, index) => {
              if (gridConfig.hasOwnProperty(index)) {
                return (
                  <Grid item xs={gridConfig[index].xs} key={index}>
                    {getComponent(data, curr_component)}
                  </Grid>
                );
              } else {
                return (
                  <Grid item xs={4} key={index}>
                    {getComponent(data, curr_component)}
                  </Grid>
                );
              }
            })}
          </Grid>
        </div>
      </div>
      <HorizontalDivider />
    </>
  );
};

const InfraSection11 = ({ getComponent, data, components, theme }) => {
  const gridConfig = {
    0: { xs: 12 },
  };
  return (
    <>
      <div
        style={{
          margin: `${theme.size[24]} ${theme.size[16]} ${theme.size[8]} ${theme.size[16]}`,
        }}
      >
        {/* Heading */}
        {data.category_name !== "" && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              // marginBottom: theme.size[8],
            }}
          >
            <Typography
              sx={{
                fontSize: theme.size[14],
                fontWeight: theme.fontWeight[500],
                color: theme.palette.rapidInfra.text,
              }}
            >
              {data.category_name}
            </Typography>

            {data.info !== "" && (
              <LightTooltip
                title={data.info}
                placement="top"
                arrow
                sx={{
                  "& .MuiTooltip-tooltip": {
                    padding: "8px 12px", // Adjust padding if needed
                  },
                }}
              >
                <InfoOutlinedIcon
                  style={{
                    fontSize: theme.size[14],
                    color: theme.palette.rapidInfra.infoIcon,
                    marginLeft: 5,
                    cursor: "pointer",
                  }}
                />
              </LightTooltip>
            )}
          </Box>
        )}

        {/* Component */}
        <div
          style={{
            // margin: `0 ${theme.size[16]} ${theme.size[24]} ${theme.size[16]}`,
            marginBottom: theme.size[24],
          }}
        >
          <Grid container columnSpacing={5}>
            {components.map((curr_component, index) => {
              if (gridConfig.hasOwnProperty(index)) {
                return (
                  <Grid item xs={gridConfig[index].xs} key={index}>
                    {getComponent(data, curr_component)}
                  </Grid>
                );
              } else {
                return (
                  <Grid item xs={4} key={index}>
                    {getComponent(data, curr_component)}
                  </Grid>
                );
              }
            })}
          </Grid>
        </div>
      </div>
      <HorizontalDivider />
    </>
  );
};

const InfraSection12 = ({ getComponent, data, components, theme }) => {
  const gridConfig = {
    0: { xs: 12 },
  };
  return (
    <>
      <div
        style={{
          margin: `${theme.size[24]} ${theme.size[16]} ${theme.size[8]} ${theme.size[16]}`,
        }}
      >
        {/* Heading */}
        {data.category_name !== "" && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              // marginBottom: theme.size[8],
            }}
          >
            <Typography
              sx={{
                fontSize: theme.size[14],
                fontWeight: theme.fontWeight[500],
                color: theme.palette.rapidInfra.text,
              }}
            >
              {data.category_name}
            </Typography>

            {data.info !== "" && (
              <LightTooltip
                title={data.info}
                placement="top"
                arrow
                sx={{
                  "& .MuiTooltip-tooltip": {
                    padding: "8px 12px", // Adjust padding if needed
                  },
                }}
              >
                <InfoOutlinedIcon
                  style={{
                    fontSize: theme.size[14],
                    color: theme.palette.rapidInfra.infoIcon,
                    marginLeft: 5,
                    cursor: "pointer",
                  }}
                />
              </LightTooltip>
            )}
          </Box>
        )}

        {/* Component */}
        <div
          style={{
            // margin: `0 ${theme.size[16]} ${theme.size[24]} ${theme.size[16]}`,
            marginBottom: theme.size[24],
          }}
        >
          <Grid container columnSpacing={5}>
            {components.map((curr_component, index) => {
              if (gridConfig.hasOwnProperty(index)) {
                return (
                  <Grid item xs={gridConfig[index].xs} key={index}>
                    {getComponent(data, curr_component)}
                  </Grid>
                );
              } else {
                return (
                  <Grid item xs={4} key={index}>
                    {getComponent(data, curr_component)}
                  </Grid>
                );
              }
            })}
          </Grid>
        </div>
      </div>
      <HorizontalDivider />
    </>
  );
};

function InfraPage({
  isRegistering,
  userEmail,
  handleNext,
  handleBack,
  register_id,
  appStatus,
}) {
  const theme = useTheme();
  const dispatch = useDispatch();
  const infraDataJson = useSelector((state) => state.data.rapidData?.infraJson);
  const detailsJson = useSelector((state) => state.data.rapidData?.detailsJson);
  const navigate = useNavigate();

  // const isAzureDatabricksEnabled = useMemo(() => {
  //   return infraDataJson[5]?.components[2]?.value === "Yes" ? true : false;
  // }, [infraDataJson]);

  const applicationName = useMemo(() => {
    return detailsJson[0]?.resources[1]?.value || "defaultApp";
  }, [detailsJson]);

  const classes = useStyles(theme);
  // Change user-input
  const handleInputChange = (categoryId, componentId, newValue) => {
    const updatedData = infraDataJson.map((category) => {
      if (category.category_id === categoryId) {
        return {
          ...category,
          components: category.components.map((component) => {
            if (component.component_id === componentId) {
              return { ...component, value: newValue };
            }
            return component;
          }),
        };
      }
      return category;
    });
    dispatch(updateRapidInfraData(updatedData));
  };

  // Change Multi-select
  const handleMultiSelectChange = (categoryId, componentId, property_id) => {
    const updatedData = infraDataJson.map((category) => {
      if (category.category_id === categoryId) {
        return {
          ...category,
          components: category.components.map((component) => {
            if (component.component_id === componentId) {
              return {
                ...component,
                properties: component.properties.map((property) => {
                  if (property.property_id === property_id) {
                    return {
                      ...property,
                      is_checked: !property.is_checked,
                    };
                  }
                  return property;
                }),
              };
            }
            return component;
          }),
        };
      }
      return category;
    });
    dispatch(updateRapidInfraData(updatedData));
  };

  const handleAddNewRequirement = (categoryId, componentId) => {
    const newRequirement = {
      id: v4(),
      name: "",
      description: "",
      cost: "",
    };

    const updatedData = infraDataJson.map((category) => {
      if (category.category_id === categoryId) {
        return {
          ...category,
          components: category.components.map((component) => {
            if (component.component_id === componentId) {
              return {
                ...component,
                value: [...(component.value || []), newRequirement],
              };
            }
            return component;
          }),
        };
      }
      return category;
    });
    dispatch(updateRapidInfraData(updatedData));
  };

  const handleDeleteRequirement = (categoryId, componentId, requirement_id) => {
    const updatedData = infraDataJson.map((category) => {
      if (category.category_id === categoryId) {
        return {
          ...category,
          components: category.components.map((component) => {
            if (component.component_id === componentId) {
              return {
                ...component,
                value: component.value.filter(
                  (item) => item.id !== requirement_id
                ),
              };
            }
            return component;
          }),
        };
      }
      return category;
    });
    dispatch(updateRapidInfraData(updatedData));
  };

  const handleCustomRequirementChange = (
    categoryId,
    componentId,
    requirement_id,
    newValue,
    type
  ) => {
    const updatedData = infraDataJson.map((category) => {
      if (category.category_id === categoryId) {
        return {
          ...category,
          components: category.components.map((component) => {
            if (component.component_id === componentId) {
              return {
                ...component,
                value: component.value.map((item) => {
                  if (item.id === requirement_id) {
                    return { ...item, [type]: newValue };
                  }
                  return item;
                }),
              };
            }
            return component;
          }),
        };
      }
      return category;
    });
    dispatch(updateRapidInfraData(updatedData));
  };

  const getComponent = (parentData, component) => {
    const {
      component_id,
      component_name,
      component_type,
      value,
      properties,
      dependencies,
      description = "",
    } = component;

    let disabledFlag = false;
    let dependent_componentName = "";

    if (dependencies) {
      dependencies.forEach((dependency) => {
        const dependentComponent = parentData.components.find(
          (component) => component.component_id === dependency.component_id
        );
        dependent_componentName = dependentComponent.component_name;
        if (dependentComponent.value !== dependency.component_value) {
          disabledFlag = true;
        }
      });
    }

    switch (component_type) {
      case "input":
        return (
          <InputField
            key={component_id}
            label={component_name}
            placeHolder={properties[0].placeholder_text}
            isRequired={component.is_required}
            type="number"
            value={value || ""}
            prefilledValue={applicationName}
            isDisabled={!isRegistering}
            onChange={handleInputChange}
            info={component.info}
            componentId={component_id}
            categoryId={parentData.category_id}
            prefix={component_name === "Application URL" ? "https://" : ""}
            suffix={component_name === "Application URL" ? ".reckitt.com" : ""}
            isTextBoxRequired={component_name === "Requestors Comments"}
          />
        );

      case "multi-select":
        return (
          <MultiSelectCheckBox
            key={component_id}
            label={component_name}
            type="multi-select"
            checkList={properties}
            isRequired={component.is_required}
            isDisabled={!isRegistering}
            onChange={handleMultiSelectChange}
            info={component.info}
            componentId={component_id}
            categoryId={parentData.category_id}
          />
        );

      case "radio":
        return (
          <RadioInput
            label={component_name}
            type="radio"
            radioList={properties}
            value={value || "No"}
            isRequired={component.is_required}
            isDisabled={
              [
                "Azure Kubernetes Cluster Required",
                "Postgre SQL Required",
                "Azure Container Registry Required",
                "Azure Key Vault Required",
              ].includes(component_name) || !isRegistering
              // ||
              // (component_name === "HDinsight Spark Cluster Required" &&
              //   isAzureDatabricksEnabled)
            }
            description={
              component_name === "Blob Storage Required"
                ? description || "*Blob Storage Size: 550TB"
                : ""
            }
            onChange={handleInputChange}
            info={component.info}
            componentId={component_id}
            categoryId={parentData.category_id}
          />
        );

      case "radio-chips":
        return (
          <RadioChips
            label={component_name}
            dependentText={
              dependent_componentName === "Postgre SQL Required"
                ? ""
                : `if ${dependent_componentName} is YES`
            }
            type="radio-chips"
            radioList={properties}
            value={
              value ||
              (component_name === "Milvus Storage Size" ? "5GB" : "Small")
            }
            isRequired={component.is_required || false}
            isDisabled={disabledFlag || !isRegistering}
            onChange={handleInputChange}
            info={component.info}
            componentId={component_id}
            categoryId={parentData.category_id}
          />
        );

      case "toggle":
        return (
          <ToggleButton
            label={component_name}
            type="toggle"
            value={value || "No"}
            isRequired={component.is_required}
            isDisabled={!isRegistering}
            onChange={handleInputChange}
            componentId={component_id}
            categoryId={parentData.category_id}
          />
        );

      case "check-box":
        return (
          <CheckboxField
            label={component_name}
            type={"check-box"}
            value={value || false}
            isRequired={component.is_required}
            isDisabled={disabledFlag || !isRegistering}
            info={""}
            onChange={handleInputChange}
            componentId={component_id}
            categoryId={parentData.category_id}
          />
        );

      case "single-select-dropdown":
        return (
          <SingleSelectDropdown
            label={component_name}
            type="single-select-dropdown"
            value={value || ""}
            placeholder=""
            options={properties}
            isRequired={component.is_required || false}
            isDisabled={disabledFlag || !isRegistering}
            componentId={component_id}
            categoryId={parentData.category_id}
            onChange={handleInputChange}
            suffix={
              component_name === "Terminate After"
                ? "minutes of inactivity"
                : ""
            }
          />
        );

      case "multi-select-dropdown":
        let options =
          component_name === "Approvers List"
            ? properties?.map((property) => {
                const str = property?.property_value;
                const result = str.split("#");
                return { name: result[0], user_id: result[1] };
              }) || []
            : component_name === "Access List"
            ? []
            : properties?.map((property) => property?.property_value) || [];

        let mediaOptions = [];
        if (component_name === "Media Support Type") {
          const genAIVal = parentData.components[0]?.value || [];
          mediaOptions = genAIVal.includes("GPT 4.o")
            ? ["Text", "Image", "Audio"]
            : genAIVal.includes("GPT 4")
            ? ["Text", "Image"]
            : [];
        }
        return ["Access List", "Approvers List"].includes(component_name) ? (
          <OktaUserMultiSelect
            label={component_name}
            type="multi-select-dropdown"
            value={value || []}
            placeholder="Select"
            options={options}
            isRequired={component.is_required || false}
            info={component.info}
            isDisabled={disabledFlag || !isRegistering}
            prefix={
              component_name === "Media Support Type"
                ? `if ${dependent_componentName} is YES`
                : ""
            }
            componentId={component_id}
            categoryId={parentData.category_id}
            onChange={handleInputChange}
            isOktaUserEnabled={
              isRegistering ? component_name === "Access List" : false
            }
            disableInputSelection={
              !isRegistering || component_name === "Approvers List"
            }
            loggedInUserEmail={userEmail}
          />
        ) : (
          <MultiSelectDropDown
            label={component_name}
            type="multi-select-dropdown"
            value={value || []}
            placeholder="Select"
            options={
              component_name === "Media Support Type" ? mediaOptions : options
            }
            isRequired={component.is_required || false}
            info={component.info}
            isDisabled={disabledFlag || !isRegistering}
            prefix={
              component_name === "Media Support Type"
                ? `If ${dependent_componentName} is YES`
                : ""
            }
            componentId={component_id}
            categoryId={parentData.category_id}
            onChange={handleInputChange}
            isOktaUserEnabled={component_name === "Access List"}
            disableInputSelection={
              !isRegistering || component_name === "Approvers List"
            }
            loggedInUserEmail={userEmail}
          />
        );
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard
      .writeText(register_id)
      .then(() => {
        dispatch(
          updateAlertInfo({
            message: "Copied",
            open: true,
            severity: "success",
          })
        );
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  const modifyInfraJsonforPrefilledData = (infraJson) => {
    const newJsonData = [];

    infraJson.map((curr_category) => {
      const modfiedComponent = [];
      curr_category.components.map((curr_component) => {
        const { component_name, component_type, value, properties } =
          curr_component;

        switch (component_type) {
          case "radio":
            if (
              [
                "Azure Kubernetes Cluster Required",
                "Postgre SQL Required",
                "Azure Container Registry Required",
                "Azure Key Vault Required",
              ].includes(component_name)
            ) {
              modfiedComponent.push({
                ...curr_component,
                value: "Yes",
              });
            } else {
              modfiedComponent.push(curr_component);
            }
            break;
          case "input":
            if (
              value === null &&
              ["Application URL", "Application Handle"].includes(component_name)
            ) {
              modfiedComponent.push({
                ...curr_component,
                value: applicationName,
              });
            } else if (
              value === null &&
              component_name === "Frontend Repos Name"
            ) {
              modfiedComponent.push({
                ...curr_component,
                value: applicationName + "-frontend" + "-repo",
              });
            } else if (
              value === null &&
              component_name === "Backend Repos Name"
            ) {
              modfiedComponent.push({
                ...curr_component,
                value: applicationName + "-backend" + "-repo",
              });
            } else {
              modfiedComponent.push(curr_component);
            }
            break;

          case "multi-select-dropdown":
            if (component_name === "Approvers List") {
              const data = properties?.map((property) => {
                const str = property?.property_value;
                const result = str.split("#");
                return { name: result[0], user_id: result[1] };
              });
              modfiedComponent.push({
                ...curr_component,
                value: data,
              });
            } else if (
              (value === null ||
                (Array.isArray(value) && value.length === 0)) &&
              component_name === "Access List"
            ) {
              // Prefill Access List with logged-in user by default
              modfiedComponent.push({
                ...curr_component,
                value: [
                  {
                    name: userEmail ? userEmail.split("@")[0] : "",
                    user_id: userEmail || "",
                  },
                ],
              });
            } else {
              modfiedComponent.push(curr_component);
            }

            break;

          default:
            modfiedComponent.push(curr_component);
            break;
        }
      });
      newJsonData.push({ ...curr_category, components: modfiedComponent });
    });

    dispatch(updateRapidInfraData(newJsonData));
  };

  useEffect(() => {
    if (
      register_id === "" ||
      appStatus ===
        APP_CONSTANTS.RAPID_STATUS.TECHNICAL_OWNER_RESPONSE_PENDING ||
      appStatus === APP_CONSTANTS.RAPID_STATUS.PROCESS_INITIATED
    ) {
      modifyInfraJsonforPrefilledData(infraDataJson);
    }
  }, []);

  useEffect(() => {
    const enviromant = getDevEnvironment(infraDataJson);
    const cost = getTotalCost(
      infraDataJson,
      enviromant?.dev,
      enviromant?.uat,
      enviromant?.prod
    );
    dispatch(updateTotalCostData(cost));
  }, [infraDataJson]);

  // const ModifyInfraJsonToDisableSparkCluster = (infraJson) => {
  //   const newJsonData = [];

  //   infraJson.map((curr_category) => {
  //     const modfiedComponent = [];
  //     curr_category.components.map((curr_component) => {
  //       const { component_name, component_type, value, properties } =
  //         curr_component;
  //       switch (component_type) {
  //         case "radio":
  //           if (component_name === "HDinsight Spark Cluster Required") {
  //             modfiedComponent.push({
  //               ...curr_component,
  //               value: "No",
  //             });
  //           } else {
  //             modfiedComponent.push(curr_component);
  //           }
  //           break;

  //         default:
  //           modfiedComponent.push(curr_component);
  //           break;
  //       }
  //     });
  //     newJsonData.push({ ...curr_category, components: modfiedComponent });
  //   });

  //   dispatch(updateRapidInfraData(newJsonData));
  // };
  // useEffect(() => {
  //   if (isAzureDatabricksEnabled) {
  //     ModifyInfraJsonToDisableSparkCluster(infraDataJson);
  //   }
  // }, [isAzureDatabricksEnabled]);

  const handleSaveAsDraft = async () => {
    const payload = {
      infra_details: infraDataJson,
      details: detailsJson,
      status: appStatus || "",
      request_id: register_id || "",
    };
    try {
      const resp = await rapidSaveAsDraft({
        payload: payload,
      });
      const statusCode = resp?.data?.status?.statusCode;
      const message = resp?.data?.status?.statusMessage;
      if (statusCode === 200) {
        navigate("/rapid");
        dispatch(
          updateAlertInfo({
            message: "Application is saved as draft",
            open: true,
            severity: "success",
          })
        );
      } else {
        dispatch(
          updateAlertInfo({
            message: message,
            open: true,
            severity: "error",
          })
        );
      }
    } catch (err) {
      console.error("Error", err);
    }
  };

  return (
    <div style={{ height: "100%" }}>
      {register_id !== "" && (
        <div
          style={{
            marginBottom: theme.size[12],
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontSize: theme.size[14],
              fontWeight: theme.fontWeight[500],
            }}
          >
            Request ID: {register_id}
          </Typography>
          <ContentCopyIcon
            sx={{
              marginLeft: theme.size[8],
              fontSize: theme.size[18],
              color: theme.palette.secondary.main,
              cursor: "pointer",
            }}
            onClick={copyToClipboard}
          />
        </div>
      )}

      <InfraSection1
        data={infraDataJson[0]}
        components={infraDataJson[0].components}
        theme={theme}
        getComponent={getComponent}
      />

      <Typography
        sx={{
          fontSize: theme.size[16],
          fontWeight: theme.fontWeight[500],
          marginTop: theme.size[24],
          color: theme.palette.rapidInfra.text,
          marginBottom: theme.size[4],
        }}
      >
        Components
      </Typography>
      <HorizontalDivider />

      <div
        style={{
          overflow: "auto",
          maxHeight:
            register_id !== "" ? "calc(100vh - 440px)" : "calc(100vh - 400px)",
        }}
      >
        <InfraSection2
          data={infraDataJson[1]}
          components={infraDataJson[1].components}
          data2={infraDataJson[2]}
          components2={infraDataJson[2].components}
          theme={theme}
          getComponent={getComponent}
        />
        <InfraSection3
          data={infraDataJson[3]}
          components={infraDataJson[3].components}
          theme={theme}
          getComponent={getComponent}
          isRegistering={isRegistering}
        />
        <InfraSection4
          data={infraDataJson[4]}
          components={infraDataJson[4].components}
          theme={theme}
          getComponent={getComponent}
        />
        {/* <InfraSection5
          data={infraDataJson[4]}
          components={infraDataJson[4].components}
          theme={theme}
          getComponent={getComponent}
        /> */}
        <InfraSection6
          data={infraDataJson[5]}
          components={infraDataJson[5].components}
          theme={theme}
          getComponent={getComponent}
        />
        <InfraSection7
          data={infraDataJson[6]}
          components={infraDataJson[6].components}
          theme={theme}
          getComponent={getComponent}
        />
        {/* LLM Options section hidden as requested */}
        {/* <InfraSection8
          data={infraDataJson[7]}
          components={infraDataJson[7].components}
          theme={theme}
          getComponent={getComponent}
        /> */}
        <InfraSection9
          data={infraDataJson[8]}
          theme={theme}
          categoryID={infraDataJson[8].category_id}
          componentID={infraDataJson[8].components[0].component_id}
          value={infraDataJson[8].components[0].value || []}
          handleAddNewRequirement={handleAddNewRequirement}
          handleDeleteRequirement={handleDeleteRequirement}
          handleCustomRequirementChange={handleCustomRequirementChange}
          isDisabled={!isRegistering}
        />
        <InfraSection10
          data={infraDataJson[9]}
          components={infraDataJson[9].components}
          theme={theme}
          getComponent={getComponent}
        />
        <InfraSection11
          data={infraDataJson[10]}
          components={infraDataJson[10].components}
          theme={theme}
          getComponent={getComponent}
        />
        <InfraSection12
          data={infraDataJson[11]}
          components={infraDataJson[11].components}
          theme={theme}
          getComponent={getComponent}
        />
      </div>

      {/* Footer */}
      {isRegistering && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            position: "absolute",
            width: "100%",
            bottom: 0,
          }}
        >
          <div style={{ display: "flex" }}>
            <div>
              <Button
                disableRipple
                className={classes.outlinedButton}
                onClick={() => handleBack()}
                style={{
                  fontWeight: theme.fontWeight[500],
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <WestIcon
                    sx={{
                      fontSize: theme.size[18],
                      marginRight: theme.size[4],
                    }}
                  />
                  <span>Back</span>
                </div>
              </Button>

              <Button
                disableRipple
                className={classes.outlinedButton}
                onClick={() => handleSaveAsDraft()}
                style={{
                  fontWeight: theme.fontWeight[500],
                  background: theme.palette.saveAsDraftButton.background,
                  color: theme.palette.saveAsDraftButton.text,
                  border: `1px solid ${theme.palette.saveAsDraftButton.background}`,
                  marginLeft: theme.size[8],
                  opacity: isNextDisabled(infraDataJson) ? 0.5 : 1,
                }}
                disabled={isNextDisabled(infraDataJson)}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <span>Save as Draft</span>
                </div>
              </Button>
              <div
                style={{
                  fontSize: theme.size[12],
                  fontWeight: theme.fontWeight[500],
                  color: theme.palette.rapidInfra.text,
                  paddingTop: theme.size[4],
                }}
              >
                Back to Request Details
              </div>
            </div>
          </div>

          <div>
            <Button
              disableRipple
              className={classes.filledButton}
              disabled={isNextDisabled(infraDataJson)}
              onClick={() => handleNext()}
              style={{
                fontWeight: theme.fontWeight[500],
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <span>Next</span>
                <EastIcon
                  sx={{
                    fontSize: theme.size[18],
                    marginLeft: theme.size[4],
                  }}
                />
              </div>
            </Button>

            <div
              style={{
                fontSize: theme.size[12],
                fontWeight: theme.fontWeight[500],
                color: theme.palette.rapidInfra.text,
                paddingTop: theme.size[4],
                textAlign: "right",
              }}
            >
              Accelerator Library
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default InfraPage;
